import moment from "moment";
import {
  colorInstructorRow,
  groupCell,
  signatureCellText,
  ELECTRONICALY_SIGNED,
  SENT_INVITE,
  PROCESSING,
  electronicSignatureCell,
  VIEWED,
  nameCell,
} from "./attendance_table_helper";
import { tweakEmail } from "../framework/signing";
import * as Popup from "../framework/components/popup";
import * as API from "../framework/api";
import * as TOAST from "../framework/components/toast";
import * as Query from "../framework/query";
import * as DataGrid from "../devextreme/datagrid";
import { columnsPlugin, dynamicHeightPlugin, multiSelectionPlugin, rowGroupPlugin } from "../devextreme/plugins";
import { pagination } from "../utils/devextreme_utils";

const doNotShowCookieName = "doNotShowSecuredAttendanceSignaturePopup";
const $container = document.querySelector("#data-grid-attendance-electronic-sign");
const attendanceSendingButtonId = "send-attendance-electronic-invitations";
const SIXTY_DAYS_IN_SECONDS = 60 * 24 * 60 * 60;
let datagridInstance;
let selectAllCheckBox;
let checkBoxUpdating = false;

document.addEventListener("DOMContentLoaded", () => {
  document.getElementById("dangerous-electronic-attendance-link")?.addEventListener("click", (e) => {
    e.preventDefault();
    showFomoPopUp(e);
  });
  document.getElementById("do_not_display_anymore")?.addEventListener("change", (e) => {
    setDoNotDisplayFlag(e);
  });

  document.getElementById(attendanceSendingButtonId)?.setAttribute("disabled", true);
  document.getElementById("automatic-secured-attendance-popup")?.addEventListener("click", (e) => {
    e.preventDefault();
    showAutomaticAttendanecSetUpPopup(e, true);
  });

  document.getElementById("automatic-attendance-popup")?.addEventListener("click", (e) => {
    e.preventDefault();
    showAutomaticAttendanecSetUpPopup(e, false);
  });

  if ($container) {
    const trainingSessionId = $container.dataset.trainingSessionId;

    DataGrid.create({
      container: $container,
      plugins: [
        columnsPlugin({
          columnDefaults: { visible: true, allowHeaderFiltering: false },
          columnOverrides: {
            subsession: {
              groupIndex: 0,
              filterValue: Query.getParam("subsession"),
              groupCellTemplate: groupCell,
            },
            slot: {
              groupIndex: 1,
              format: (it) => moment(it).format("Do MMM YYYY - HH:mm"),
              filterValue: Query.getParam("date") ? new Date(Query.getParam("date")) : undefined,
              groupCellTemplate: groupCell,
            },
            name: {
              fixed: true,
              sortOrder: "asc",
              cellTemplate: nameCell,
              allowHeaderFiltering: true,
            },
            status: {
              fixed: true,
              sortOrder: "asc",
              cellTemplate: electronicSignatureCell,
              customizeText: signatureCellText,
              allowHeaderFiltering: true,
            },
            generated_file_link: {
              allowSorting: false,
              cellTemplate: generatedFileLinkCell,
            },
          },
        }),
        rowGroupPlugin({ allowCollapsing: false }),
        multiSelectionPlugin({ onChanged: onSelectionChanged }),
        dynamicHeightPlugin(),
        {
          onDataGridCreated() {
            datagridInstance = this;
            this.getDataSource()
              .store()
              .load()
              .done((allData) => {
                const showAlertAttendeeNoEmail = allData.some((element) => element.email == null);
                document.getElementById("alert_attendee_no_email").classList.toggle(showAlertAttendeeNoEmail);
              });
            addCancelEvents(null);
            document.getElementById(attendanceSendingButtonId)?.addEventListener("click", post_electronic_sign);
          },
          onContentReady: addCancelEvents,
          options: {
            columnAutoWidth: true,
            dataSource: p`/ajax/training_sessions/${trainingSessionId}/attendance`,
            onCellPrepared: colorInstructorRow,
            onEditorPreparing: onEditorPreparing,
            ...pagination(250, 500, 1000),
          },
        },
      ],
    });
  }
});

const $signedTemplate = document.querySelector(".js-file-link-signed-template");
const $cancelTemplate = document.querySelector(".js-file-link-cancel-template");

function generatedFileLinkCell(cellElement, cellInfo) {
  const { status, generated_file_link, proof_link, id } = cellInfo.row.data;

  if (ELECTRONICALY_SIGNED === status) {
    const $cellContent = $signedTemplate.content.cloneNode(true);
    $cellContent.querySelector(".js-file-link-download").href = generated_file_link;
    $cellContent.querySelector(".js-file-link-proof").href = proof_link;
    cellElement.appendChild($cellContent);
  } else if ([PROCESSING, SENT_INVITE].includes(status)) {
    const $cellContent = $cancelTemplate.content.cloneNode(true);
    $cellContent.querySelector(".js-cancel-electronic-attendance").dataset.id = id;
    cellElement.appendChild($cellContent);
  }
}

function addCancelEvents(_e) {
  document
    .querySelectorAll(".js-cancel-electronic-attendance")
    .forEach((x) => x.addEventListener("click", cancelElectronicAttendance));
}

async function cancelElectronicAttendance(event) {
  const lineId = event.currentTarget.getAttribute("data-id");
  const isYes = await Popup.confirm("#cancel-electronic-attendance-popup");
  if (isYes) {
    const query = {
      method: "POST",
      redirect: "manual",
      body: JSON.stringify({ id: lineId }),
      headers: {
        "Content-Type": "application/json",
      },
    };
    const response = await API.fetch(
      p`/ajax/training_sessions/${$container.dataset.trainingSessionId}/attendance/cancel_electronic`,
      query
    );
    if (response.ok) {
      TOAST.show("#electronic-cancel-success-toast");
      datagridInstance.deselectAll();
      datagridInstance.refresh();
    } else {
      TOAST.show("#electronic-cancel-error-toast");
    }
  }
}

function isSelectAll(dataGrid) {
  const selectableItems = dataGrid
    .getDataSource()
    ._items.flatMap((x) => x.items.flatMap((x) => x.items))
    .filter(isSelectable);
  const selectedRowKeys = dataGrid.option("selectedRowKeys");
  if (!selectedRowKeys.length) {
    return false;
  }
  return selectedRowKeys.length >= selectableItems.length ? true : undefined;
}

function onEditorPreparing(e) {
  let dataGrid = e.component;
  if (e.type !== "selection") return;
  if (e.parentType === "dataRow" && e.row && !isSelectable(e.row.data)) e.editorOptions.disabled = true;
  if (e.parentType === "headerRow") {
    e.editorOptions.onInitialized = (e) => {
      if (e.component) selectAllCheckBox = e.component;
    };
    e.editorOptions.value = isSelectAll(dataGrid);
    e.editorOptions.onValueChanged = (e) => {
      if (!e.event) {
        if (e.previousValue && checkBoxUpdating) e.component.option("value", e.previousValue);
        return;
      }
      if (isSelectAll(dataGrid) === e.value) return;
      e.value ? dataGrid.selectAll() : dataGrid.deselectAll();
      e.event.preventDefault();
    };
  }
}

function isSelectable(row) {
  return ![SENT_INVITE, ELECTRONICALY_SIGNED, PROCESSING, VIEWED].includes(row.status) && row.email != null && row.email != "";
}

function onSelectionChanged(e) {
  var deselectRowKeys = [];
  if (e.selectedRowsData.length > 0) {
    document.getElementById(attendanceSendingButtonId).removeAttribute("disabled");
  } else {
    document.getElementById(attendanceSendingButtonId).setAttribute("disabled", true);
  }
  e.selectedRowsData.forEach((item) => {
    if (!isSelectable(item)) deselectRowKeys.push(e.component.keyOf(item));
  });
  if (deselectRowKeys.length) {
    e.component.deselectRows(deselectRowKeys);
  }
  checkBoxUpdating = true;
  selectAllCheckBox.option("value", isSelectAll(e.component));
  checkBoxUpdating = false;
}

async function post_electronic_sign(e) {
  e.preventDefault();
  const warnings = [];

  const url = document.getElementById(attendanceSendingButtonId).dataset.postUrl;

  const selectedKeys = datagridInstance.getSelectedRowsData().filter((row) => isSelectable(row));

  const visibleRows = datagridInstance
    .getVisibleRows()
    .filter((it) => it.rowType == "data")
    .map((it) => {
      const isSelected = selectedKeys.some((selected) => selected.id === it.key.id);
      if ([SENT_INVITE, ELECTRONICALY_SIGNED, PROCESSING].includes(it.key.status) && !isSelected) {
        warnings.push(it.key);
      }
      return [it.key.id, isSelected];
    })
    .filter((elem) => elem[1] === true);

  if (visibleRows.length > 0) {
    const email_template = await tweakEmail("training_session");
    if (email_template != null) {
      const response = await API.fetchJSON(url, {
        method: "POST",
        redirect: "manual",
        body: JSON.stringify({
          values: visibleRows,
          subject: email_template.subject,
          body: email_template.body,
        }),
        headers: { "Content-Type": "application/json" },
      });

      const emailToast = response.status == "ok" ? "#electronic-success-toast" : "#electronic-conflict-toast";
      TOAST.show(emailToast);

      datagridInstance.deselectAll();
      datagridInstance.refresh();
    }
  } else {
    TOAST.show("#electronic-no-line-toast");
  }
}

function showFomoPopUp(_e) {
  const myPopup = document.getElementById("secured_attendance_warning");
  const doNotShowSecuredAttendanceSignaturePopup = document.cookie
    .split(";")
    .some((item) => item.trim().startsWith(doNotShowCookieName + "=true"));
  if (doNotShowSecuredAttendanceSignaturePopup) {
    const url = document.getElementById("extranet_attendance_url").getAttribute("href");
    window.open(url, "_blank").focus();
  } else {
    Popup.open(myPopup);
  }
}

function showAutomaticAttendanecSetUpPopup(_e, isSecured) {
  let myPopup;
  if (isSecured) {
    myPopup = document.getElementById("popup-setup-secured");
  } else {
    myPopup = document.getElementById("popup-setup-not-secured");
  }
  if (myPopup) {
    Popup.open(myPopup);
  }
}

function setDoNotDisplayFlag(_e) {
  const myCheckBox = document.getElementById("do_not_display_anymore");
  document.cookie = `${doNotShowCookieName}=${myCheckBox.checked};;max-age=${SIXTY_DAYS_IN_SECONDS}`;
}
